const environmentVariables = {
  graphqlBaseUrl: 'https://backend.titirodigital.it/graphql'
};

export default environmentVariables;
